@if (list | async; as list) {
    <div class="tab-content" [@fadeIn]>
        <section class="section">
            <h2 class="section__heading section__heading--large list-title">{{ list.title }}</h2>
            @for (contract of list.contracts; track contract.name; let j = $index) {
                <h2 class="section__heading">{{ contract.name }}</h2>
                <ul class="bullet-list link-list contract-list">
                    @for (resource of contract.resources; track resource.name; let j = $index) {
                        <li class="bullet-list__item link-list__item contract-list__item">
                            @if (resource.name) {
                                <grainger-icon-list-item
                                    [link]="resource"
                                    (clicked)="onContractClick(resource)"
                                    [disableEdit]="true"
                                ></grainger-icon-list-item>
                            }
                            @if (resource.description) {
                                <p class="description" [innerHTML]="resource.description"></p>
                            }
                        </li>
                    }
                    @if (contract.description) {
                        <p class="description" [innerHTML]="contract.description"></p>
                    }
                </ul>
            }
        </section>
    </div>
}
